import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, clientOnly = false, allowedRoles = null }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-loading-screen">
        <div className="h-8 w-8 border-2 border-[#76C121] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (clientOnly) {
    if (user.role !== "client") return <Navigate to="/" replace />;
    return children;
  }
  if (user.role === "client") return <Navigate to="/portal" replace />;
  if (user.role === "ca") {
    if (allowedRoles && allowedRoles.includes("ca")) return children;
    return <Navigate to="/financial-overview" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
